import { MeetingRequestViewStateHost } from '../store/schema/MeetingRequestViewState';
import RequestStatus from '../store/schema/RequestStatus';
import ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { action } from 'satcheljs/lib/legacy';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';

export default action('initializeMeetingRequestViewState')(
    function initializeMeetingRequestViewState(itemViewState: MeetingRequestViewStateHost) {
        itemViewState.meetingRequestViewState = {
            conflictsShown: false,
            editorViewState: {
                ...createEditorViewState(''),
                sendResponse: true,
            },
            groupEventAdded: false,
            responseType: 'Unknown' as ResponseTypeType,
            conflictsRequestStatus: RequestStatus.NotInitiated,
            showProposeNewTime: true,
        };
    }
);
